webpackJsonp([7],{

/***/ "+skl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("kmMG");


/***/ }),

/***/ "0UwV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


// 开发环境
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.setConfig = function (config) {
	__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL = config.BASE_URL;
	__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.timeout = config.AJAX_TIMEOUT;
	// axios.defaults.withCredentials = true; // 表示跨域请求时是否需要使用凭证,也可自动把后台set的cookie存起来
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_axios___default.a);

/***/ }),

/***/ "6A3X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6WAP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


var util = {};
util.title = function (title) {
	title = title || 'first App';
	window.document.title = title;
};

util.inOf = function (arr, targetArr) {
	var res = true;
	arr.forEach(function (item) {
		if (targetArr.indexOf(item) < 0) {
			res = false;
		}
	});
	return res;
};

util.oneOf = function (ele, targetArr) {
	if (targetArr.indexOf(ele) >= 0) {
		return true;
	} else {
		return false;
	}
};

util.showThisRoute = function (itAccess, currentAccess) {
	if ((typeof itAccess === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(itAccess)) === 'object' && Array.isArray(itAccess)) {
		return util.oneOf(currentAccess, itAccess);
	} else {
		return itAccess === currentAccess;
	}
};

util.getRouterObjByName = function (routers, name) {
	if (!name || !routers || !routers.length) {
		return null;
	}
	// debugger;
	var routerObj = null;
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(routers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var item = _step.value;

			if (item.name === name) {
				return item;
			}
			routerObj = util.getRouterObjByName(item.children, name);
			if (routerObj) {
				return routerObj;
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return null;
};

util.handleTitle = function (vm, item) {
	if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(item.title) === 'object') {
		return vm.$t(item.title.i18n);
	} else {
		return item.title;
	}
};

util.openNewPage = function (vm, name, argu, query) {
	var pageOpenedList = vm.$store.state.app.pageOpenedList;
	var openedPageLen = pageOpenedList.length;
	var i = 0;
	var tagHasOpened = false;
	while (i < openedPageLen) {
		if (name === pageOpenedList[i].name) {
			// 页面已经打开
			vm.$store.commit('pageOpenedList', {
				index: i,
				argu: argu,
				query: query
			});
			tagHasOpened = true;
			break;
		}
		i++;
	}
	if (!tagHasOpened) {
		var tag = vm.$store.state.app.tagsList.filter(function (item) {
			if (item.children) {
				return name === item.children[0].name;
			} else {
				return name === item.name;
			}
		});
		tag = tag[0];
		if (tag) {
			tag = tag.children ? tag.children[0] : tag;
			if (argu) {
				tag.argu = argu;
			}
			if (query) {
				tag.query = query;
			}
			vm.$store.commit('increateTag', tag);
		}
	}
	vm.$store.commit('setCurrentPageName', name);
};

util.toDefaultPage = function (routers, name, route, next) {
	var len = routers.length;
	var i = 0;
	var notHandle = true;
	while (i < len) {
		if (routers[i].name === name && routers[i].children && routers[i].redirect === undefined) {
			route.replace({
				name: routers[i].children[0].name
			});
			notHandle = false;
			next();
			break;
		}
		i++;
	}
	// console.log('notHandle=' + notHandle);
	if (notHandle) {
		next();
	}
};

util.fullscreenEvent = function (vm) {
	vm.$store.commit('initCachepage');
	// 权限菜单过滤相关
	vm.$store.commit('updateMenulist');
	// 全屏相关
};

util.isEmpty = function (value) {
	if (value === undefined || value === null || value === 'null' || value === '' || value.length <= 0) {
		return true;
	} else {
		return false;
	}
};
var path = {};
util.setCurrentPath = function (appname) {
	var currentPath = window.location.href;
	path[appname] = currentPath;
	// console.log('path>>>' + JSON.stringify(path));
};
util.getCurrentPath = function (appname) {
	var currentPath = path[appname];
	console.log(appname + 'currentPath>>>' + currentPath);
	return currentPath;
};

function formatTimeNumber(n) {
	n = n.toString();
	return n[1] ? n : '0' + n;
}

// 格式化日期，返回yyyy-mm-dd
util.formatDate = function (time) {
	if (time) {
		if (time.length === 10) time = time * 1000;
		var tmpDate = new Date(parseInt(time));
		var year = tmpDate.getFullYear();
		var month = tmpDate.getMonth() + 1;
		var day = tmpDate.getDate();
		return year + '-' + formatTimeNumber(month) + '-' + formatTimeNumber(day);
	}
	return '';
};
// 格式化日期，返回yyyy-mm-dd hh:mm:ss
util.formatDateTime = function (time) {
	if (time) {
		if (time.length === 10) time = time * 1000;
		var tmpDate = new Date(parseInt(time));
		var year = tmpDate.getFullYear();
		var month = tmpDate.getMonth() + 1;
		var day = tmpDate.getDate();
		var hour = tmpDate.getHours();
		var min = tmpDate.getMinutes();
		var sec = tmpDate.getSeconds();
		return year + '-' + formatTimeNumber(month) + '-' + formatTimeNumber(day) + ' ' + formatTimeNumber(hour) + ':' + formatTimeNumber(min) + ':' + formatTimeNumber(sec);
	}
	return '';
};
// 格式化日期，返回hh:mm:ss
util.formatTime = function (time) {
	if (time) {
		if (time.length === 10) time = time * 1000;
		var tmpDate = new Date(parseInt(time));
		var hour = tmpDate.getHours();
		var min = tmpDate.getMinutes();
		var sec = tmpDate.getSeconds();
		return formatTimeNumber(hour) + ':' + formatTimeNumber(min);
	}
	return '';
};
// 回车搜索
util.quickSearch = function (formName, fn) {
	var inputs = document.querySelector('.' + formName).querySelectorAll("input[type='text']");
	inputs.forEach(function (item) {
		item.onkeypress = function (v) {
			if (v.charCode === 13) {
				fn();
			}
		};
	});
};
// 大图预览
util.showBigPic = function (url) {
	var shadow = document.createElement('div');
	shadow.className = 'bp-shadow';
	shadow.onclick = function () {
		if (this) {
			document.body.removeChild(this);
		}
	};
	// 优化点击遮罩层并拖拽导致的图片蓝色背景问题
	shadow.onmousedown = function () {
		document.onmousemove = function () {
			return false;
		};
	};
	var wrap = document.createElement('div');
	wrap.className = 'bp-wrap';
	var img = document.createElement('img');
	img.src = url;
	document.body.appendChild(shadow);
	wrap.appendChild(img);
	shadow.appendChild(wrap);
};
// 切换loading的背景图标的显示隐藏
util.toggleEmptyBlock = function (state) {
	setTimeout(function () {
		var empty_block = document.getElementsByClassName('el-table__empty-block')[0];
		if (empty_block) {
			if (state === 'hidden') {
				empty_block.classList.remove('empty-data');
			} else if (state === 'visible') {
				empty_block.classList.add('empty-data');
			}
		}
		var empty_list = document.getElementsByClassName('no-data')[0];
		if (empty_list) {
			if (state === 'hidden') {
				empty_list.classList.remove('empty');
			} else if (state === 'visible') {
				empty_list.classList.add('empty');
			}
		}
	}, 100);
};
// 图片宽高显示
util.initImg = function () {
	setTimeout(function () {

		console.log('遍历图片=========');
		var imgList = document.querySelectorAll('img');
		// console.log(imgList);
		// console.log(imgList.length);

		var _loop = function _loop(img) {
			// console.log('img=====', img);
			// console.log('src=====', img.src);
			if (img && img.src) {
				var cur = new Image();
				cur.src = img.src;
				cur.onload = function () {
					console.log('width:' + img.width + ',height:' + img.height);

					if (img.width >= img.height) {
						img.style.width = '100%';
						img.style.height = 'auto';
					}
					if (img.width < img.height) {
						img.style.height = '100%';
						img.style.width = 'auto';
					}
				};
			}
		};

		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;

		try {
			for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(imgList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var img = _step2.value;

				_loop(img);
			}
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2.return) {
					_iterator2.return();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}
	}, 0);
};
/**
 * 返回mm
 */
/**
 *  返回正确的姓名表达式
 */
util.trueName = function (rule, value, callback) {
	console.log(2222222222222, rule, value, callback);
	var reg = /(^[\u4e00-\u9fa5]{1}[\u4e00-\u9fa5\.·。]{0,49}[\u4e00-\u9fa5]{1}$)|(^[a-zA-Z]{1}[a-zA-Z\s \.]{0,49}[a-zA-Z]{1}$)/;
	if (value) {
		var len = value.length;
		var len2 = value.replace(/\s+/g, '').length;
		var c = len - len2 < 2;
		if (c) {
			console.log(!reg.test(value), '!reg.test(value)');
			if (!reg.test(value)) {
				callback(new Error('姓名格式错误')); // 不能输入(像!@#$%^&*以及空格等
			} else {
				callback();
			}
		} else {
			callback(new Error('姓名格式错误'));
		}
	} else {
		callback();
	}
};
//根据当前时间判断历史视频结束时间
util.setEndTime = function (time) {
	var newDate = new Date().getTime();
	if (new Date(time).getTime() > newDate) {
		newDate = this.formatDateTime(newDate);
		return newDate;
	} else {
		return time;
	}
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),

/***/ "8+PR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_main_common_ajax_config__ = __webpack_require__("0UwV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_main_router__ = __webpack_require__("YBq8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_main_utils_auth__ = __webpack_require__("McCK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);







var refreshConfig = [];
var errorFlag = false;
// 添加请求拦截器
__WEBPACK_IMPORTED_MODULE_1_main_common_ajax_config__["a" /* default */].interceptors.request.use(function (config) {
	if (config.method === 'get' || config.method === 'delete') {
		config.params = config.data;
	}
	if (config.url.indexOf('/authz/refreshToken') > -1) {
		// refreshtoken不需要loading状态
		return config;
	}
	refreshConfig.push(config);
	return config;
}, function (error) {
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// 响应拦截器
__WEBPACK_IMPORTED_MODULE_1_main_common_ajax_config__["a" /* default */].interceptors.response.use(function (response) {
	if (response.headers.token) {
		Object(__WEBPACK_IMPORTED_MODULE_3_main_utils_auth__["b" /* setAccessToken */])(response.headers.token);
	}
	var originalConfig = response.config;
	var AccessTokenKey = 'jwt_token';
	var RefreshTokenKey = 'refresh_token';
	if (window.location.href.indexOf('login') >= 0) {
		setTimeout(function () {
			errorFlag = false;
		}, 2000);
	}
	return response;
}, function (error) {
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// 登录的时候要form表单提交请求中多了form参数
/* harmony default export */ __webpack_exports__["a"] = ({
	ajax: function ajax(url, method, params) {
		var from = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			var config = null;
			// 针对文件下载，单独的头设置
			if (from && from === 'download') {
				config = {
					url: url,
					method: method,
					responseType: 'blob',
					headers: {
						'Content-type': 'application/json;charset=utf-8',
						'Accept': 'application/octet-stream'
					}
				};
			} else if (from && from !== 'download') {
				config = {
					url: url,
					method: method,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				};
				config.transformRequest = [function (data) {
					var ret = '';
					for (var it in data) {
						ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
					}
					return ret;
				}];
			} else if (!from) {
				config = {
					url: url,
					method: method,
					headers: {}
				};
				// 登录的时候检查用户后台不能传jwt_token，连传空值都不行，所以这里做了处理
				if (url.indexOf('auth/login') !== -1) {
					config.headers = {
						'Content-type': 'application/json;charset=utf-8'
					};
				} else {
					config.headers = {
						'Content-type': 'application/json;charset=utf-8',
						'token': Object(__WEBPACK_IMPORTED_MODULE_3_main_utils_auth__["a" /* getAccessToken */])()
					};
				}
			}
			config.data = params;
			Object(__WEBPACK_IMPORTED_MODULE_1_main_common_ajax_config__["a" /* default */])(config).then(function (response) {
				// 如果是下载，就不走正常的请求判断
				if (response.headers['content-type'] === 'application/octet-stream') {
					var fileInfo = {
						name: response.headers['content-disposition'].split('=')[1],
						content: response.data
					};
					resolve(fileInfo);
				}
				// 请求接口正确且成功时
				if (response.data.status === 200) {
					resolve(response.data.result ? response.data.result : response.data);
				} else if (response.data.status === 500) {
					if (response.data.message == 'token is error') {
						reject('请重新登录');
						__WEBPACK_IMPORTED_MODULE_2_main_router__["a" /* default */].push({ path: '/login' });
					}
					// 非正常错误
					if (response.data.message.indexOf('exception') > -1 || response.data.message.indexOf('Exception') > -1) {
						reject('系统异常');
					} else {
						// 请求接口错误或不成功时
						if (response.data.message) {
							reject(response.data.message);
						} else {
							// 请求接口错误或不成功时
							reject('服务器崩溃了~~~');
						}
					}
				} else if (response.data.status === 403) {
					// 403没有权限
					reject(response.data.message);
				} else if (response.data.status === 401 || response.data.code === 401 || response.data.code == -1 && response.data.message === '用户jwt签名错误' || response.data.code == -1 && response.data.message === '用户jwt过期') {
					__WEBPACK_IMPORTED_MODULE_2_main_router__["a" /* default */].push({ path: '/login' });
				} else if (response.data.status === 400 || response.data.status === 1001) {
					reject(response.data.message);
				} else {
					reject('请求失败~~~');
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),

/***/ "EOGq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_ajax__ = __webpack_require__("8+PR");

/**
 * 公共的ajax数据服务
 */


var service = {};
/**
 * 登录
 * @returns {*}
 */
service.login = function (params) {
	return __WEBPACK_IMPORTED_MODULE_1__common_ajax__["a" /* default */].ajax('/login', 'get', params, 'form');
};

/**
* refresh token
* @returns {*}
*/
service.refershToken = function (params) {
	return __WEBPACK_IMPORTED_MODULE_1__common_ajax__["a" /* default */].ajax('/authz/refershToken', 'post', params, 'form');
};

/**
 * 退出登录
 * @returns {*}
 */
service.logout = function () {
	return __WEBPACK_IMPORTED_MODULE_1__common_ajax__["a" /* default */].ajax('/authz/logout', 'post', null);
};
// 获取左侧菜单树
service.getAuthTree = function () {
	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		resolve([{
			'menuName': '小程序管理',
			'menuPath': '/icmp',
			'iconClass': 'icon-icon-projectmanagement',
			'menus': []
		}, {
			'menuName': '公众号管理',
			'menuPath': '/icmp/official-account-manage',
			'iconClass': 'icon-icon-projectmanagement',
			'menus': []
		}, {
			'menuName': '开放平台管理',
			'menuPath': '/icmp/open-platform-manage',
			'iconClass': 'icon-icon-projectmanagement',
			'menus': []
		}, {
			'menuName': '客户管理',
			'menuPath': '/icmp/customer-manage',
			'iconClass': 'icon-icon-projectmanagement',
			'menus': []
		}]);
	});
};
/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ "Erld":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "H8lQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M56Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "McCK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAccessToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = setAccessToken;
/* unused harmony export isAuth */
/* harmony export (immutable) */ __webpack_exports__["c"] = setAuthTree;
/* unused harmony export removeToken */
/* unused harmony export setExpiresIn */
/* unused harmony export getExpiresIn */
/* unused harmony export removeExpiresIn */
/* unused harmony export RefreshTokenLoop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("6WAP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_login__ = __webpack_require__("EOGq");



var AccessTokenKey = 'jwt_token';
var ExpiresInKey = 'expires_in';
var menuSignArray = [];
var buttonSignArray = [];
function getAccessToken() {
	var token = sessionStorage.getItem(AccessTokenKey);
	if (__WEBPACK_IMPORTED_MODULE_1__util__["a" /* default */].isEmpty(token)) {
		token = '';
	}
	return token;
}

function setAccessToken(token) {
	sessionStorage.setItem(AccessTokenKey, token);
}
function isAuth(name) {
	var pathArray = JSON.parse(sessionStorage.getItem('menu_sign_array'));
	return pathArray && pathArray.indexOf(name) > -1;
}
function setAuthTree(tree) {
	sessionStorage.setItem('auth_menu_array', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([]));
	sessionStorage.setItem('auth_menu_array', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(tree));
	// 在设置之前要先清空，因为换账号的时候会存留之前的菜单数据
	// sessionStorage.setItem('menu_sign_array', JSON.stringify([]));
	// sessionStorage.setItem('button_sign_array', JSON.stringify([]));
	// sessionStorage.setItem('auth_menu_array', JSON.stringify([]));
	// if (!tree || tree.length < 1) {
	// 	return;
	// }
	// menuSignArray = [];
	// buttonSignArray = [];
	// let treeMenu = JSON.parse(JSON.stringify(tree));
	// let list = transformMenu(treeMenu);
	// sessionStorage.setItem('menu_sign_array', JSON.stringify(menuSignArray));
	// sessionStorage.setItem('button_sign_array', JSON.stringify(buttonSignArray));
	// sessionStorage.setItem('auth_menu_array', JSON.stringify(list));
}
function transformMenu(list) {
	var allBtn = true;
	list.forEach(function (menu) {
		menu.type === '10' ? menuSignArray.push(menu.sign) : buttonSignArray.push(menu.sign);
		if (menu.type === '10') {
			allBtn = false;
			menu.menuName = menu.name;
			menu.menuPath = '/icmp' + menu.url;
			if (menu.fields) {
				for (var i = menu.fields.length - 1; i >= 0; i--) {
					if (menu.fields[i].name === 'iconClass') {
						menu.iconClass = menu.fields[i].description;
						break;
					}
				}
			}
			menu.menus = [];
			if (menu.children) {
				menu.menus = menu.children;
			}
			if (menu.children && menu.children.length > 0) {
				menu.menus = transformMenu(menu.children);
			}
		}
	});
	return allBtn ? [] : list;
}

function removeToken() {
	return sessionStorage.removeItem(AccessTokenKey);
}

function setExpiresIn(expiresIn) {
	sessionStorage.setItem(ExpiresInKey, expiresIn);
}

function getExpiresIn() {
	var expiredIn = sessionStorage.getItem(ExpiresInKey);
	if (expiredIn) {
		return parseInt(expiredIn);
	} else {
		return 0;
	}
}

function removeExpiresIn() {
	return sessionStorage.removeItem(ExpiresInKey);
}

var RefreshTokenTimer;

function RefreshTokenLoop() {
	var next = parseInt(sessionStorage.getItem('REFRERSH_TOKEN_TIME')); // 25 分钟之后
	if (RefreshTokenTimer) {
		clearTimeout(RefreshTokenTimer);
	}
	RefreshTokenTimer = setTimeout(function () {
		var params = { refreshToken: refreshToken || '' };
		__WEBPACK_IMPORTED_MODULE_2__service_login__["a" /* default */].refreshToken(params).then(function (res) {
			if (res.jwt_token) {
				sessionStorage.setItem(AccessTokenKey, res.jwt_token);
			}
		});
		RefreshTokenLoop();
	}, next);
}

/***/ }),

/***/ "WWNr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YBq8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/kd-sidemenu/kd-sidemenu.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var kd_sidemenu = ({
	props: {
		isCollapse: {
			type: Boolean,
			default: false
		},
		menuData: {
			type: Object,
			default: {
				menus: []
			}
		}
	},
	data: function data() {
		return {
			activeNav: '/icmp'
		};
	},
	created: function created() {},
	mounted: function mounted() {
		this.setHight();
	},

	methods: {
		handleOpen: function handleOpen(key, keyPath) {
			// console.log(key, keyPath);
		},
		handleClose: function handleClose(key, keyPath) {
			// console.log(key, keyPath);
		},
		setHight: function setHight() {
			var path = this.$route.path;
			// 处理二级路由菜单不高亮
			if (path.indexOf('deploy-photos') > -1) {
				path = '/icmp/deploy-store';
			}
			if (path.indexOf('grid-manage') > -1) {
				path = '/icmp/grid-manage';
			}
			this.activeNav = path;
		}
	},
	watch: {
		$route: {
			handler: function handler(val) {
				this.setHight();
			},

			deep: true
		}
	},
	computed: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fa4eeca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/kd-sidemenu/kd-sidemenu.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kd-sidemenu"},[_c('div',{staticClass:"sidemenu-wrapper"},[_c('div',{staticClass:"side-menu-group"},[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"router":true,"collapse":_vm.isCollapse,"default-active":_vm.activeNav,"unique-opened":true,"background-color":"transparent","text-color":"#fff","active-text-color":"#fff"},on:{"open":_vm.handleOpen,"close":_vm.handleClose}},_vm._l((_vm.menuData.menus),function(item,findex){return _c('div',{key:findex},[(item.menus && item.menus.length === 0 )?_c('el-menu-item',{key:findex,staticClass:"el-menu-single",attrs:{"index":item.menuPath}},[_c('span',[_c('i',{staticClass:"iconfont",class:item.iconClass})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.menuName))])]):_vm._e()],1)}),0)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var kd_sidemenu_kd_sidemenu = (esExports);
// CONCATENATED MODULE: ./components/kd-sidemenu/kd-sidemenu.vue
function injectStyle (ssrContext) {
  __webpack_require__("H8lQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fa4eeca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  kd_sidemenu,
  kd_sidemenu_kd_sidemenu,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_kd_sidemenu_kd_sidemenu = (Component.exports);

// CONCATENATED MODULE: ./components/kd-sidemenu/index.js

/* harmony default export */ var components_kd_sidemenu = (components_kd_sidemenu_kd_sidemenu);

// EXTERNAL MODULE: ./main/assets/img/icon-police.png
var icon_police = __webpack_require__("Erld");
var icon_police_default = /*#__PURE__*/__webpack_require__.n(icon_police);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("lbHh");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./main/service/login/index.js
var service_login = __webpack_require__("EOGq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/kd-header/kd-header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var kd_header = ({
	props: {
		isCollapse: {
			type: Boolean,
			default: false
		}
	},
	data: function data() {
		return {
			userId: '',
			headerSearch: null,
			collapsed: false,
			head: icon_police_default.a
		};
	},
	mounted: function mounted() {
		var winWidth = document.body.clientWidth || document.documentElement.clientWidth;
		if (winWidth <= 1440) {
			this.collapsed = true;
		}
	},

	methods: {
		routeTo: function routeTo() {
			this.$router.push({ path: '/icmp/' });
		},

		// 点击个跳转个人中心 退出
		handleCommand: function handleCommand(command) {
			if (command === 'a') {
				this.$router.push({ path: '/icmp/personal-center' });
			} else if (command === 'b') {
				window.sessionStorage.removeItem('jwt_token');
				// 清除左边菜单相关数据
				window.sessionStorage.removeItem('menu_sign_array');
				window.sessionStorage.removeItem('button_sign_array');
				window.sessionStorage.removeItem('auth_menu_array');
				this.$router.push({ path: '/login' });
			}
		},

		// 点击跳转到个人中心 ()
		routeLink: function routeLink() {
			this.$router.push({ path: '/icmp/personal-center' });
		},
		handleCollapsed: function handleCollapsed() {
			this.collapsed = !this.collapsed;
			this.$emit('getToggle', { isCollapse: this.collapsed });
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-013168c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/kd-header/kd-header.vue
var kd_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kd-header clearfix"},[_c('div',{staticClass:"kd-header-logo",on:{"click":_vm.routeTo}},[_c('a',[_vm._v("微信小程序路由代理服务中心")])]),_vm._v(" "),_c('div',{staticClass:"kd-header-btns"},[_c('a',{staticClass:"kd-h-user",attrs:{"title":"用户"}},[_c('el-dropdown',{attrs:{"trigger":"click"},on:{"command":_vm.handleCommand}},[_c('span',{staticClass:"el-dropdown-link"},[_c('img',{attrs:{"src":_vm.head,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"iconfont icon-pull down icon-icon-pulldown"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"kd-header-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"b"}},[_vm._v("退出")])],1)],1)],1)])])}
var kd_header_staticRenderFns = []
var kd_header_esExports = { render: kd_header_render, staticRenderFns: kd_header_staticRenderFns }
/* harmony default export */ var kd_header_kd_header = (kd_header_esExports);
// CONCATENATED MODULE: ./components/kd-header/kd-header.vue
function kd_header_injectStyle (ssrContext) {
  __webpack_require__("WWNr")
}
var kd_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var kd_header___vue_template_functional__ = false
/* styles */
var kd_header___vue_styles__ = kd_header_injectStyle
/* scopeId */
var kd_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var kd_header___vue_module_identifier__ = null
var kd_header_Component = kd_header_normalizeComponent(
  kd_header,
  kd_header_kd_header,
  kd_header___vue_template_functional__,
  kd_header___vue_styles__,
  kd_header___vue_scopeId__,
  kd_header___vue_module_identifier__
)

/* harmony default export */ var components_kd_header_kd_header = (kd_header_Component.exports);

// CONCATENATED MODULE: ./components/kd-header/index.js

/* harmony default export */ var components_kd_header = (components_kd_header_kd_header);
// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./main/view/main/Main.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import {getMenuList} from 'main/service/menu';


/* harmony default export */ var Main = ({
	name: 'ppl-home',
	components: {
		KdHeader: components_kd_header,
		KdSidemenu: components_kd_sidemenu
	},
	data: function data() {
		return {
			menuData: {
				menus: []
			},
			isCollapse: false,
			isMap: true,
			titleList: [],
			showBread: false
		};
	},

	computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getTitleList']), {
		key: function key() {
			this.getTitle();
			console.log(this.$route.name);
			return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date();
		}
	}),
	mounted: function mounted() {
		var winWidth = document.body.clientWidth || document.documentElement.clientWidth;
		if (winWidth <= 1440) {
			this.isCollapse = true;
			this.kdSlideMenuIsCollapse(); // 菜单是否折叠 vuex
			document.getElementsByClassName('kd-sidemenu')[0].classList.add('nav-hide');
		}
		// document.getElementById('main').addEventListener('scroll', this.handleScroll);
		// 面包屑横向滚动监听改变left位置
		window.addEventListener('scroll', this.scorllHorizontal);
	},
	created: function created() {
		this.menuData.menus = sessionStorage.getItem('auth_menu_array') ? JSON.parse(sessionStorage.getItem('auth_menu_array')) : [];
	},

	methods: {
		// 处理滚动条距离
		// handleScroll() {
		// 	let scrollTop = document.getElementById('main').scrollTop;
		// 	this.$store.commit('updateScrollTop', scrollTop);
		// },
		handleChange: function handleChange(page) {
			if (page === 'ppl-logout') {
				this.$store.commit('logout', this);
				this.$router.push({
					name: 'login'
				});
			} else {
				this.$router.push({
					name: page
				});
			}
			;
		},
		toggleBtnClick: function toggleBtnClick(msg) {
			this.isCollapse = msg.isCollapse;
			if (this.isCollapse) {
				document.getElementsByClassName('kd-sidemenu')[0].classList.add('nav-hide');
			} else {
				document.getElementsByClassName('kd-sidemenu')[0].classList.remove('nav-hide');
			}
			this.kdSlideMenuIsCollapse(); // 菜单是否折叠 vuex
		},
		getTitle: function getTitle() {
			if (sessionStorage.getItem('titleList') !== undefined || sessionStorage.getItem('titleList') !== null) {
				switch (this.$route.name) {
					case 'map-index':
						this.$store.dispatch('setTitle', [{ name: '小程序管理', route: '' }]);
						this.showBread = true;
						break;
					case 'project-detail':
						this.$store.dispatch('setTitle', [{
							name: '小程序管理',
							route: '/icmp'
						}, { name: '小程序项目详情', route: '' }]);
						this.showBread = true;
						break;
					case 'official-account-manage':
						this.$store.dispatch('setTitle', [{ name: '公众号管理', route: '' }]);
						this.showBread = true;
						break;
					case 'official-account-detail':
						this.$store.dispatch('setTitle', [{
							name: '公众号管理',
							route: '/official-account-manage'
						}, { name: '公众号项目详情', route: '' }]);
						this.showBread = true;
						break;
					case 'open-platform-manage':
						this.$store.dispatch('setTitle', [{ name: '开放平台管理', route: '' }]);
						this.showBread = true;
						break;
					case 'customer-manage':
						this.$store.dispatch('setTitle', [{ name: '客户管理', route: '' }]);
						this.showBread = true;
						break;
					default:
						this.showBread = false;
						break;
				}
			} else {
				this.titleList = sessionStorage.getItem('titleList');
			}
		},

		// 面包屑横向滚动监听改变left位置
		scorllHorizontal: function scorllHorizontal(width) {
			var fixedDom = document.getElementsByClassName('breadcrumb-header')[0];
			var scrollLeft = document.getElementsByTagName('html')[0].scrollLeft;
			var menuWidth = this.isCollapse ? 38 : 180;
			if (!fixedDom) {
				return;
			}
			fixedDom.style.left = menuWidth - scrollLeft + 'px';
			fixedDom.style.width = document.documentElement.clientWidth;
		},

		// 菜单是否折叠 vuex
		kdSlideMenuIsCollapse: function kdSlideMenuIsCollapse() {
			this.$store.dispatch('setIsCollapse', this.isCollapse);
		}
	},
	watch: {
		isCollapse: function isCollapse(newVal, oldVal) {
			this.scorllHorizontal(newVal ? 38 : 180);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b48d49a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./main/view/main/Main.vue
var Main_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main",attrs:{"id":"main-wrapper"}},[_c('el-container',{staticClass:"ppl-wrapper"},[_c('el-header',[_c('KdHeader',{on:{"getToggle":_vm.toggleBtnClick}})],1),_vm._v(" "),_c('el-container',{staticClass:"ppl-container"},[_c('el-aside',{attrs:{"width":"100px"}},[_c('KdSidemenu',{attrs:{"isCollapse":_vm.isCollapse,"menuData":_vm.menuData}})],1),_vm._v(" "),_c('el-main',{staticClass:"map-no-padding",attrs:{"id":"main"}},[(_vm.showBread)?_c('div',{staticStyle:{"height":"40px","min-height":"40px"}}):_vm._e(),_vm._v(" "),(_vm.showBread)?_c('el-header',{staticClass:"breadcrumb-header",staticStyle:{"height":"40px","min-height":"40px"}},[_c('span',{staticStyle:{"float":"left","font-family":"PingFangSC-Regular","font-size":"12px","color":"#575A5F","letter-spacing":"0"}},[_vm._v("您的当前位置：")]),_vm._v(" "),_c('el-breadcrumb',{staticStyle:{"float":"left","font-family":"PingFangSC-Regular","font-size":"12px","color":"#8C9097","letter-spacing":"0"},attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.getTitleList),function(item,index){return _c('el-breadcrumb-item',{key:index,attrs:{"value":item.name,"to":item.route}},[_vm._v(_vm._s(item.name)+"\n                        ")])}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"line"}),_vm._v(" "),_c('router-view',{key:_vm.key})],1)],1)],1)],1)}
var Main_staticRenderFns = []
var Main_esExports = { render: Main_render, staticRenderFns: Main_staticRenderFns }
/* harmony default export */ var main_Main = (Main_esExports);
// CONCATENATED MODULE: ./main/view/main/Main.vue
function Main_injectStyle (ssrContext) {
  __webpack_require__("M56Z")
}
var Main_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Main___vue_template_functional__ = false
/* styles */
var Main___vue_styles__ = Main_injectStyle
/* scopeId */
var Main___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Main___vue_module_identifier__ = null
var Main_Component = Main_normalizeComponent(
  Main,
  main_Main,
  Main___vue_template_functional__,
  Main___vue_styles__,
  Main___vue_scopeId__,
  Main___vue_module_identifier__
)

/* harmony default export */ var view_main_Main = (Main_Component.exports);

// EXTERNAL MODULE: ./main/utils/util.js
var util = __webpack_require__("6WAP");

// EXTERNAL MODULE: ./main/utils/auth.js
var auth = __webpack_require__("McCK");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./main/view/login/Login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Login = ({
	name: 'login',
	data: function data() {
		return {
			loading: false,
			loginData: {
				username: js_cookie_default.a.get('username') ? js_cookie_default.a.get('username') : '',
				password: js_cookie_default.a.get('password') ? js_cookie_default.a.get('password') : ''
			},
			remberUser: false, // 记住密码
			loginFormRules: {
				username: [{ required: true, message: '用户名不能为空', trigger: 'blur' }],
				password: [{ required: true, message: '密码不能为空', trigger: 'blur' }]
			}
		};
	},
	created: function created() {
		// 如果之前选了记住密码，则重新进入这个页面需要记住密码被勾选
		var username = js_cookie_default.a.get('username');
		var password = js_cookie_default.a.get('password');
		if (username && password) {
			this.remberUser = true;
		} else {
			this.remberUser = false;
		}
	},
	mounted: function mounted() {
		var _this = this;
		util["a" /* default */].quickSearch('login-right', function () {
			_this.login('loginForm');
		});
	},

	methods: {
		/**
   * 验证用户名密码是否都正确，去请求后台
   * @param formName
   */
		login: function login(formName) {
			var _this2 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					_this2.loading = true;
					// 再去获取token
					var params = {
						account: _this2.loginData.username,
						password: _this2.loginData.password
					};
					service_login["a" /* default */].login(params).then(function (res) {
						Object(auth["b" /* setAccessToken */])(res.token); // 往sessionStorage存放'jwt_token'的值
						// 如果选了记住密码
						if (_this2.remberUser) {
							js_cookie_default.a.set('username', _this2.loginData.username, { expires: 30 }); // 不设置cookie过期时间默认会话关闭即过期，现在是30天过期
							js_cookie_default.a.set('password', _this2.loginData.password, { expires: 30 }); // 不设置cookie过期时间默认会话关闭即过期，现在是30天过期
						} else {
							js_cookie_default.a.remove('username');
							js_cookie_default.a.remove('password');
						}
						window.sessionStorage.setItem('userName', _this2.loginData.username);
						service_login["a" /* default */].getAuthTree().then(function (res) {
							_this2.loading = false;
							Object(auth["c" /* setAuthTree */])(res);
							document.onkeypress = '';
							_this2.$router.push({ path: '/icmp/' }); // 跳转到系统首页
						}).catch(function (err) {
							_this2.loading = false;
							_this2.$message.error(err);
						});
					}).catch(function (err) {
						_this2.loading = false;
						_this2.$message.error(err);
					});
				}
			});
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-535c0714","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./main/view/login/Login.vue
var Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_c('div',{staticClass:"wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"login-right"},[_c('el-form',{ref:"loginForm",attrs:{"model":_vm.loginData,"rules":_vm.loginFormRules}},[_c('div',{staticClass:"top-line"}),_vm._v(" "),_c('h2',[_vm._v("登录")]),_vm._v(" "),_c('div',{staticClass:"user-name"},[_c('el-form-item',{attrs:{"prop":"username"}},[_c('el-input',{attrs:{"placeholder":"用户名","auto-complete":"off"},model:{value:(_vm.loginData.username),callback:function ($$v) {_vm.$set(_vm.loginData, "username", $$v)},expression:"loginData.username"}},[_c('i',{staticClass:"iconfont icon-icon-name",attrs:{"slot":"prefix"},slot:"prefix"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"user-password"},[_c('el-form-item',{attrs:{"prop":"password"}},[_c('el-input',{attrs:{"placeholder":"登录密码","type":"password","auto-complete":"off"},model:{value:(_vm.loginData.password),callback:function ($$v) {_vm.$set(_vm.loginData, "password", $$v)},expression:"loginData.password"}},[_c('i',{staticClass:"iconfont icon-icon-lock",attrs:{"slot":"prefix"},slot:"prefix"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"user-rember-password"},[_c('el-checkbox',{model:{value:(_vm.remberUser),callback:function ($$v) {_vm.remberUser=$$v},expression:"remberUser"}},[_vm._v("记住用户名和密码")])],1),_vm._v(" "),_c('div',{staticClass:"valid-button"},[_c('el-button',{attrs:{"type":"primary","id":"keybtn","loading":_vm.loading},on:{"click":function($event){return _vm.login('loginForm')}}},[_vm._v("登录"+_vm._s(_vm.loading?'中':''))])],1)])],1),_vm._v(" "),_c('div',{staticClass:"login-left"}),_vm._v(" "),_c('div',{staticClass:"copyright"},[_vm._v("版本号信息："+_vm._s(_vm.g_Config.versionNo))])])])}
var Login_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('span'),_vm._v("微信小程序路由代理服务中心\n\t\t")])}]
var Login_esExports = { render: Login_render, staticRenderFns: Login_staticRenderFns }
/* harmony default export */ var login_Login = (Login_esExports);
// CONCATENATED MODULE: ./main/view/login/Login.vue
function Login_injectStyle (ssrContext) {
  __webpack_require__("t62W")
}
var Login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Login___vue_template_functional__ = false
/* styles */
var Login___vue_styles__ = Login_injectStyle
/* scopeId */
var Login___vue_scopeId__ = "data-v-535c0714"
/* moduleIdentifier (server only) */
var Login___vue_module_identifier__ = null
var Login_Component = Login_normalizeComponent(
  Login,
  login_Login,
  Login___vue_template_functional__,
  Login___vue_styles__,
  Login___vue_scopeId__,
  Login___vue_module_identifier__
)

/* harmony default export */ var view_login_Login = (Login_Component.exports);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// CONCATENATED MODULE: ./main/router/index.js







vue_esm["default"].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
	routes: [{
		path: '/',
		name: '',
		meta: { sign: 'IS_NOT_REQUIRE' },
		redirect: '/login'
	}, {
		path: '/login',
		name: 'login',
		meta: { sign: 'IS_NOT_REQUIRE' },
		title: '登录',
		component: view_login_Login
	}, {
		path: '/icmp',
		name: 'icmp',
		title: '首页',
		meta: { sign: 'AUTH_INDEX' },
		component: view_main_Main,
		children: [
		// 首页
		{
			path: '',
			title: '小程序管理',
			name: 'map-index',
			meta: { sign: 'AUTH_INDEX' },
			icon: 'arrow-move',
			component: function component() {
				return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "vS2N"));
			}
		}, {
			path: 'project-detail',
			title: '小程序项目详情',
			name: 'project-detail',
			meta: { sign: 'AUTH_DETAIL' },
			component: function component() {
				return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "wYtV"));
			}
		},
		// 公众号管理
		{
			path: 'official-account-manage',
			title: '公众号管理',
			name: 'official-account-manage',
			meta: { sign: 'OFFICIAL_ACCOUNT_MANAGE' },
			icon: 'arrow-move',
			component: function component() {
				return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "GReY"));
			}
		}, {
			path: 'official-account-detail',
			title: '公众号项目详情',
			name: 'official-account-detail',
			meta: { sign: 'OFFICIAL_ACCOUNT__DETAIL' },
			component: function component() {
				return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "GVEk"));
			}
		},
		// 公众号管理
		{
			path: 'open-platform-manage',
			title: '开放平台管理',
			name: 'open-platform-manage',
			meta: { sign: 'OPEN_PLATFORM_MANAGE' },
			icon: 'arrow-move',
			component: function component() {
				return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "vfL2"));
			}
		}, {
			path: 'customer-manage',
			title: '客户管理',
			name: 'customer-manage',
			meta: { sign: 'CUSTOMER_MANAGE' },
			component: function component() {
				return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "cYxv"));
			}
		}]
	}]
});

router.beforeEach(function (to, from, next) {
	if (to.matched.length > 0 && to.matched[1] && (to.matched[1].name === 'map-index' || to.matched[1].name === 'grid-manage-edit')) {
		// 所有map页面html类名样式
		document.getElementsByTagName('html')[0].className = 'map-html';
	} else {
		document.getElementsByTagName('html')[0].className = (to.path.split('/')[2] || to.path.split('/')[1]) + '-page';
	}
	if (true) {
		next();
	} else {
		if (!isAuth(to.meta.sign)) {
			if (to.meta.sign == 'AUTH_INDEX') {
				next({
					path: '/icmp/personal-center'
				});
			} else {
				Message({
					message: '对不起，您没有权限！',
					type: 'error'
				});
				next({
					path: '/login'
				});
			}
		} else {
			next();
		}
	}
});
/* harmony default export */ var main_router = __webpack_exports__["a"] = (router);

/***/ }),

/***/ "eP6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kmMG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./main/router/index.js + 14 modules
var router = __webpack_require__("YBq8");

// EXTERNAL MODULE: ./main/common/ajax/config.js
var ajax_config = __webpack_require__("0UwV");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./main/store/head-title.js

var SET_TITLE = 'SET_TITLE';
var PUSH_TITLE = 'PUSH_TITLE';
/* harmony default export */ var head_title = ({
	state: {
		titleList: [],
		isCollapse: false // 菜单是否折叠
	},
	getters: {
		getTitleList: function getTitleList(state) {
			return state.titleList;
		},
		isCollapse: function isCollapse(state) {
			return state.isCollapse;
		}
	},
	mutations: {
		SET_TITLE: function SET_TITLE(state, list) {
			state.titleList = list;
		},
		PUSH_TITLE: function PUSH_TITLE(state, list) {
			state.titleList.push(list);
		},
		setIsCollapse: function setIsCollapse(state, isCollapse) {
			state.isCollapse = isCollapse;
		}
	},
	actions: {
		setTitle: function setTitle(_ref, list) {
			var commit = _ref.commit;

			commit(SET_TITLE, list);
			window.window.sessionStorage.titleList = stringify_default()(list);
		},
		pushTitle: function pushTitle(_ref2, list) {
			var commit = _ref2.commit;

			commit(PUSH_TITLE, list);
		},

		// 赋值
		setIsCollapse: function setIsCollapse(_ref3, isCollapse) {
			var commit = _ref3.commit;

			commit('setIsCollapse', isCollapse);
		}
	}
});
// CONCATENATED MODULE: ./main/store/index.js




vue_esm["default"].use(vuex_esm["a" /* default */]);

var store = new vuex_esm["a" /* default */].Store({
	modules: {
		headTitle: head_title
	}
});

/* harmony default export */ var main_store = (store);
// EXTERNAL MODULE: ./node_modules/normalize.css/normalize.css
var normalize = __webpack_require__("uMhA");
var normalize_default = /*#__PURE__*/__webpack_require__.n(normalize);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./node_modules/iview/dist/iview.js
var iview = __webpack_require__("BTaQ");
var iview_default = /*#__PURE__*/__webpack_require__.n(iview);

// EXTERNAL MODULE: ./node_modules/iview/dist/styles/iview.css
var styles_iview = __webpack_require__("+skl");
var styles_iview_default = /*#__PURE__*/__webpack_require__.n(styles_iview);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/theme-chalk/index.css
var theme_chalk = __webpack_require__("tvR6");
var theme_chalk_default = /*#__PURE__*/__webpack_require__.n(theme_chalk);

// EXTERNAL MODULE: ./main/assets/scss/public.scss
var scss_public = __webpack_require__("eP6c");
var public_default = /*#__PURE__*/__webpack_require__.n(scss_public);

// EXTERNAL MODULE: ./node_modules/vue2-animate/dist/vue2-animate.min.css
var vue2_animate_min = __webpack_require__("6A3X");
var vue2_animate_min_default = /*#__PURE__*/__webpack_require__.n(vue2_animate_min);

// EXTERNAL MODULE: ./main/assets/iconfont/iconfont.css
var iconfont = __webpack_require__("wm8E");
var iconfont_default = /*#__PURE__*/__webpack_require__.n(iconfont);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./main/App.vue
//
//
//
//
//
//


/* harmony default export */ var App = ({
	name: 'app',
	provide: function provide() {
		return {
			reload: this.reload
		};
	},
	data: function data() {
		return {
			msg: '',
			isRouterAlive: true
		};
	},

	methods: {
		reload: function reload() {
			// this.isRouterAlive = false;
			// this.$nextTick(() => (this.isRouterAlive = true));
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f29ff7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./main/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_main_App = (esExports);
// CONCATENATED MODULE: ./main/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("og1/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_main_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var main_App = (Component.exports);

// CONCATENATED MODULE: ./main/main.js

// app入口文件
// 初始化 路由、样式、语言、store、全局配置global.json
















vue_esm["default"].config.productionTip = false;
vue_esm["default"].use(element_ui_common_default.a);
vue_esm["default"].use(iview_default.a);

ajax_config["a" /* default */].get('static/config/global.json').then(function (res) {
	var config = res.data;
	config.BASE_URL =  false ? config.DEV_BASE_URL :  false ? config.LOCAL_BASE_URL : config.BASE_URL;

	vue_esm["default"].prototype.g_Config = config;
	ajax_config["a" /* default */].setConfig(vue_esm["default"].prototype.g_Config);
	sessionStorage.setItem('picBaseUrl', config.BASE_URL);
	sessionStorage.setItem('REFRERSH_TOKEN_TIME', config.REFRERSH_TOKEN_TIME); // 刷新token时间
	sessionStorage.setItem('APPLICATION_TYPE', stringify_default()(config.APPLICATION_TYPE)); // 刷新token时间

	/* eslint-disable no-new */
	window.vue = new vue_esm["default"]({
		el: '#app',
		router: router["a" /* default */],
		store: main_store,
		template: '<App/>',
		components: { App: main_App }
	});
}).catch(function (err) {
	console.log(err);
});

/***/ }),

/***/ "og1/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t62W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uMhA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wm8E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/main.dbfd5a4fb0094762f441.js